export default function isAlreadySolved(challengeDataToShow: any): boolean {
    if (challengeDataToShow.challenger === "NA")
        return false
    return true
}